"use client";

import { TimelineContainer } from "./timeline-container";
import { FlightItineraryInner } from "./flight-itinerary-inner";
import { iFlightLegDetails } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";
import { useIsMobile } from "@/hooks/use-mobile";
import { airlineList } from "../helpers/airline-list";
import { useQuoteTheme } from "../quote-theme/use-quote-theme";
import { getFlightItineraryLayoutFromTheme } from "../quote-theme/use-quote-theme-styles";
import { useHolidayQuoteBrand } from "../contexts/use-holiday-quote-brand";
import { isTripMode } from "../trip-mode/partition-itinerary-for-trip-mode";

export function FlightItinerary(
  props: iFlightLegDetails & {
    primaryColor?: string;
    layout?: "layout_1" | "layout_2";
  }
) {
  const { layoutConfig } = useQuoteTheme();
  const { quote } = useHolidayQuoteBrand();
  const showChrome = !isTripMode(quote?.data?.mode);
  const layout =
    props.layout ?? getFlightItineraryLayoutFromTheme(layoutConfig);
  const isMobile = useIsMobile();

  const getTitle = () => {
    if (layout !== "layout_1") return props.title || "Flight";
    const airlineDetails = airlineList.find(
      (a) => a.name === props.airline || a.id === props.airline
    );
    if (isMobile) {
      return props.flightNumber
        ? `${airlineDetails?.name || props.airline} ${props.flightNumber}`
        : airlineDetails?.name || props.airline || props.title || "Flight";
    }
    return props.title || "Flight";
  };

  return (
    <TimelineContainer
      title={getTitle()}
      icon={(props.icon as any) || "plane"}
      showChrome={showChrome}
    >
      <FlightItineraryInner {...props} layout={layout} />
    </TimelineContainer>
  );
}
